const styles = (theme) => ({
  item: {
    justifyContent: 'space-between',
    padding: theme.spacing(2.5),
  },
  title: {
    display: 'flex',
    alignItems: 'center',
  },
  indicator: {
    marginRight: theme.spacing(2.5),
  },
});

export default styles;
